export type Jurisdiction = 'UK' | 'EU' | 'OTHER';

export interface ConsentCategories {
  strictly_necessary: true;
  analytics: boolean;
  marketing: boolean;
  functional: boolean;
}

export interface ConsentState {
  categories: ConsentCategories;
  timestamp: number;
  policyVersion: string;
  jurisdiction: Jurisdiction;
}

export type ConsentCategoryKey = keyof ConsentCategories;

export const ALL_GRANTED: ConsentCategories = {
  strictly_necessary: true,
  analytics: true,
  marketing: true,
  functional: true,
};

export const ALL_DENIED: ConsentCategories = {
  strictly_necessary: true,
  analytics: false,
  marketing: false,
  functional: false,
};
